"use strict";
module.exports = entity => entity;
